import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledFixedHelpingArrows = styled('div')(
  () => css`
    .fixed-helping-arrows {
      background-color: #4c6fff;
      padding: 4px 16px;
      border-radius: 6px;
      display: flex;
      gap: 16px;
      position: fixed;
      bottom: 24px;
      left: 0;
      right: 0;
      margin: 0 auto;
      max-width: max-content;
      color: #ffffff;
      z-index: 9999;

      .arrow-wrapper {
        display: flex;
        align-items: center;
      }

      .arrow-icon {
        background-color: #ffffff;
        border-radius: 6px;
        margin-left: 4px;
        color: #9caebb;
      }

      .arrow-label {
        font-size: 0.75rem;
        line-height: 1.5rem;
        font-weight: 400;
      }
    }

    @media (max-width: 960px) {
      .fixed-helping-arrows {
        right: 0 !important;
      }
    }

    @media (max-width: 600px) {
      .fixed-helping-arrows {
        display: none;
      }
    }
  `
);
